import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const PlusIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 5V19M5 12H19"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

PlusIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(PlusIcon);
